export default {
  setIsSaved({commit}, value) {
    commit('setIsSaved', value);
  },
};


// WEBPACK FOOTER //
// ./src/modules/bids/vuex/actions.js